import React from "react";
import { Container } from "@telia/teddy";
import cn from "classnames";
import _capitalize from "lodash/capitalize";
import { MemberCardInfo } from "./CollapsedMemberCard";
import { AccountSubscription } from "../../../../../models/state";
import { getFormattedPrice } from "../../../../../shared/priceFormatter";
import { PhoneNumberFormatters } from "../../../app/utils";
import "./ExistingMemberCard.less";

const regularFormatter = PhoneNumberFormatters[0].displayFn;
const capitalizeEachWord = (str: string): string => {
    return str
        .split(" ")
        .map((word) => _capitalize(word))
        .join(" ");
};

interface ExistingMemberCardProps {
    existingSubscription: AccountSubscription;
}

const ExistingMemberCard: React.FC<ExistingMemberCardProps> = ({ existingSubscription }) => {
    const { phoneNumber, name, shouldGetFamilyDiscount, monthlyPrice, monthlyLinesPrice } = existingSubscription;
    const isNormal = phoneNumber?.length && phoneNumber.length === 8;
    const productUserName = `${existingSubscription.firstName} ${existingSubscription.lastName}`;
    const hasPrice = monthlyPrice !== undefined && !isNaN(monthlyPrice);
    const hasLinesPrice = monthlyLinesPrice !== undefined && !isNaN(monthlyLinesPrice);

    return (
        <Container asChild className={cn("existing-member-card__section", "existing-member-card__section-margin")}>
            <div className="existing-member-card__section-inner">
                <MemberCardInfo
                    subscriptionName={name}
                    shouldGetFamilyDiscount={shouldGetFamilyDiscount}
                    familyDiscountBadgeOverride="Vil få familierabatt"
                    title={`${capitalizeEachWord(productUserName || "")}${isNormal ? ` - ${regularFormatter(phoneNumber)}` : ""}`}
                    isCompleted
                    isExisting
                    price={
                        hasPrice || hasLinesPrice
                            ? getFormattedPrice(
                                  shouldGetFamilyDiscount && hasLinesPrice
                                      ? monthlyLinesPrice.toString()
                                      : monthlyPrice?.toString(),
                              )
                            : undefined
                    }
                    discountPrice={
                        hasPrice ? (shouldGetFamilyDiscount && hasLinesPrice ? monthlyPrice : undefined) : undefined
                    }
                />
            </div>
        </Container>
    );
};

export default ExistingMemberCard;
